<template>
    <div class="container">
        <v-tabs-items v-model="tab" class="tab-item-container">
            <v-tab-item v-for="(config, key) in imageFormatsConfig" :key="key" :transition="false" class="tab-item">
                <div class="image-container">
                    <ImageCropper
                        class="image-cropper"
                        :image="image"
                        :aspect-ratio="config.width / config.height"
                        :initial-data="
                            imageCropData && typeof imageCropData === 'object' && imageCropData[key]
                                ? imageCropData[key]
                                : null
                        "
                        @crop="onCrop(key, $event)"
                    />
                    <div class="tgk-paragraph-text text-right">
                        {{ config.text }}: {{ config.width }}x{{ config.height }}px
                    </div>
                </div>
            </v-tab-item>
        </v-tabs-items>
        <h4>Bitte bestimme die verschiedenen Bildformate:</h4>
        <v-tabs v-model="tab" class="tabs mt-2" active-class="tab-active" grow>
            <KpTooltip v-for="(config, key) in imageFormatsConfig" :key="key">
                <template #activator="{ on }">
                    <v-tab v-on="on">
                        {{ config.text }}
                    </v-tab>
                </template>
                <span>{{ config.desc || '' }}</span>
            </KpTooltip>
        </v-tabs>
    </div>
</template>

<script>
import { Image } from '@/models/Image';
import ImageCropper from '@/components/ImageCropper.vue';
import KpTooltip from '../KpTooltip.vue';

/**
 * This component is part of the Image Crop functionality of the Media manager.
 * It displays all formats to be cropped in tabs.
 *
 * Emits:
 *
 * - crop(confKey, cropData, this.image)
 */
export default {
    name: 'MediaManagerImageFormatTabs',
    components: { ImageCropper, KpTooltip },
    props: {
        /**
         * Image format configs for a specific scope (e.g. magazin), structured like GLOBALS.featured_images_config.magazin, e.g.:
         * {
         *     front_header: {
         *         ident: 'front_header',
         *         width: 400,
         *         height: 300,
         *         overlay_preview: true,
         *         ....
         *     }
         * }
         */
        imageFormatsConfig: {
            type: Object,
            required: true,
        },

        /**
         * The selected Image record
         */
        image: {
            type: Image,
            required: true,
        },
        // initial / crop info to use when opening / changing an existing image
        imageCropData: {
            type: Object,
            required: false,
            default: null,
        },
    },
    data() {
        return {
            tab: 0,
        };
    },
    methods: {
        onCrop(confKey, cropData) {
            this.$emit('crop', confKey, cropData, this.image);
        },
    },
};
</script>

<style lang="scss" scoped>
.container {
    display: flex;
    flex-direction: column;

    .tabs {
        flex: 0;
        :deep(.v-tab) {
            text-transform: none;
            border-right: 1px solid var(--gray-label-color);
            &:last-child {
                border-right: none;
            }
            background-color: var(--gray-border-color);
        }

        .tab-active {
            background-color: var(--primary-color);
            color: white;
        }
    }

    .tab-item-container {
        flex: 1;

        :deep(.v-window__container) {
            height: 100%;

            .tab-item {
                height: 100%;

                .image-container {
                    height: 100%;

                    display: flex;
                    flex-direction: column;

                    .image-cropper {
                        flex: 1;
                        overflow: auto;
                    }
                }
            }
        }
    }
}
</style>
